export default {
    forgotYourPassword: 'Forgot your password',
    textResetYourPassword: 'We will email you a link to reset your password. Please confirm your registered email below',
    emailAddress: 'Email address',
    enterYourEmailAddress: 'Enter your email address',
    sendEmail: 'Send Email',
    emailSent: 'Email Sent',
    returnToLogIn: 'Return to Log in',
    resetPasswordLink: 'Reset password link has been sent to',
    notThisEmail: 'Not This Email?',
    emailAddressIsRequired: 'Email address is required',
    emailAddressIsNotValid: 'Email address is not valid'
}
